import {
	CarriagesIcon,
	InventoryIcon,
	LoggingIcon,
	LogoutIcon,
	SensorIcon
} from '../components'
import {
	RNCarriers,
	RNLogout,
	RNLogging,
	RNLoggingCodes,
	RNUsers,
	// RNSensors,
	RNBalance,
	RNUpdatesDashboard,
	RNUpdatesMachines,
	RNUpdatesVersions,
	RNUpdatesDeploy,
	RNUpdatesCarrierTypes,
	RNInventoryEquipment,
	RNInventoryInstallations,
	RNInventoryInspections
} from './routeNames'

export type Children = Pick<
	SideBarMenuItem,
	'path' | 'name' | 'isAdmin'
> & {
	activeProblemsCount?: number
}

export interface SideBarMenuItem {
	path: string
	name: string
	Icon: any
	last?: boolean
	isAdmin?: boolean
	children?: Children[]
	isOpen?: boolean
}

export const sideBarMenuItems: (
	carriersBar: Children[]
) => SideBarMenuItem[] = (carriersBar) => [
	// {
	// 	path: RNCarrierGroups,
	// 	name: 'Carrier Groups',
	// 	Icon: CarriagesIcon,
	// },
	{
		path: RNCarriers,
		name: 'Carriers',
		Icon: CarriagesIcon,
		children: carriersBar
	},
	// {
	// 	path: RNSensors,
	// 	name: 'Sensors',
	// 	Icon: SensorIcon
	// },
	{
		path: RNBalance,
		name: 'Balance',
		Icon: SensorIcon,
		isAdmin: true
	},
	{
		path: RNLogging,
		name: 'Logging',
		Icon: LoggingIcon
	},
	{
		path: RNLoggingCodes,
		name: 'LoggingCodes',
		Icon: LoggingIcon,
		isAdmin: true
	},
	{
		path: RNUsers,
		name: 'Users',
		Icon: LoggingIcon,
		isAdmin: true
	},
	{
		path: RNUpdatesDashboard,
		name: 'Updates',
		Icon: SensorIcon,
		isAdmin: true,
		children: [
			{ path: RNUpdatesDashboard, name: 'Dashboard', isAdmin: true },
			{ path: RNUpdatesMachines, name: 'Machines', isAdmin: true },
			{ path: RNUpdatesVersions, name: 'Versions', isAdmin: true },
			{ path: RNUpdatesDeploy, name: 'Deploy', isAdmin: true },
			{
				path: RNUpdatesCarrierTypes,
				name: 'Carrier Types',
				isAdmin: true
			}
		]
	},
	{
		path: RNInventoryEquipment,
		name: 'Inventory',
		Icon: InventoryIcon,
		children: [
			{ path: RNInventoryEquipment, name: 'Equipment' },
			{ path: RNInventoryInstallations, name: 'IoT Devices' },
			{ path: RNInventoryInspections, name: 'Inspections' }
		]
	},
	{
		path: RNLogout,
		name: 'Logout',
		Icon: LogoutIcon,
		last: true
	}
]
